import { SystemPresence } from './system-presence.model';

export enum ExtendedPresenceState {
  Available = 1,
  Away = 2
}

export interface ExtendedPresence extends SystemPresence {
  state: ExtendedPresenceState;
}
